import '../../styles/CalendarStyles.css';
import './AddUsers.scss';

import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';

import checkMark from '../../assets/images/icons/check-mark.svg';
import chevronLeft from '../../assets/images/icons/chevron-left.svg';
import FormDatePicker from '../../components/FormDatePicker/FormDatePicker';
import InputForm from '../../components/InputForm/InputForm';
import SelectForm from '../../components/SelectForm/SelectForm';
import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';
import api from '../../services/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { auth } from '../../firebase/firebaseConfig';
import { createUserWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import Button from '../../components/Buttons/Button';

const AddUsers = () => {
  const navigate = useNavigate();


  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  // How the new account gets in: a one-time sign-in link texted from the 866 (opens the
  // app on a create-password screen), or the older password-reset email.
  const [delivery, setDelivery] = useState('login_link');
  // Empty, not today. The picker below renders with no defaultDate, so it looks
  // blank while seeding a real value, and every account added without touching
  // it was being stored as born today.
  const [birthday, setBirthday] = useState('');
  const [gender, setGender] = useState('');
  const [ig, setIg] = useState('');

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    // Optional, like Edit User and like the server: 360 live accounts have none.
    lastName: Yup.string().trim(),
    phone: Yup.string().required("Phone number is required"),
    // Optional with a texted link: they add their email on the link screen.
    email: Yup.string().trim().email("Invalid email")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, { message: 'Invalid email format', excludeEmptyString: true })
      .when('delivery', { is: 'email', then: (s) => s.required('Email is required to email a password reset') }),
    gender: Yup.string().required("Gender is required"),
    // ig: Yup.string().required("Instagram is required"),
  });

  const handleAddUserSubmit = async (event) => {
    event.preventDefault();
    try {
      await validationSchema.validate({
        firstName,
        lastName,
        phone,
        email,
        gender,
        delivery,
        // ig,
      }, { abortEarly: false });

      setSaving(true)


      // const userCredential = await createUserWithEmailAndPassword(
      //   auth,
      //   email,
      //   uuidv4()
      // )

      // if (!userCredential) {
      //   alert('Could not create firebase user.');
      //   return;
      // }

      // await sendPasswordResetEmail(auth, email);

      // const { uid } = userCredential.user;

      // Trimmed here because Yup's .trim() only transforms the copy it
      // validates; it never touches the values posted below.
      const newUser = {
        firstName: (firstName || '').trim(),
        lastName: (lastName || '').trim(),
        phone: (phone || '').trim(),
        email: (email || '').trim(),
        birthday,
        gender,
        ig,
        delivery,
      }

      const created = await api.post("/users/firebase", newUser);
      const link = created?.data?.login_link;

      setFirstName("");
      setLastName("");
      setPhone("");
      setEmail("");
      setGender("");
      setIg("");

      // `link` present means a text was asked for: anything but sent is a warning.
      if (link?.sent) toast.success(`User added. Sign-in link texted to ${link.sent_to}.`);
      else if (link) toast.warn(`User added, but the sign-in text did not go out (${link.send_error || 'unknown'}). Fix the number if needed and send the link from Edit User.`);
      else toast.success('User added.');

      navigate("/users");
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const validationErrors = {};
        error.inner.forEach(err => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
        toast.error(`Error Adding User. Please try again, ${error.message}`);
      } else {
        // Was console-only, and the one toast it did have compared against a
        // message string the server never sends ("This email is already in
        // use."), so a duplicate email showed nothing at all. Show what the
        // server actually said.
        console.error("Error adding user:", error);
        toast.error(error?.response?.data?.message || error?.message || 'Could not add that user. Please try again.');
      }
    } finally {
      setSaving(false)
    }
  }


  const handleBirthdaySelect = (selectedBirthday) => {

    setBirthday(selectedBirthday)
  };


  const optionsGender = [{ value: "Male", label: "Male" }, { value: "Female", label: "Female" }]
  const optionsDelivery = [
    { value: 'login_link', label: 'Text a sign-in link (they create a password in the app)' },
    { value: 'email', label: 'Email a password reset' },
  ]






  return (
    <main>
      <TopNav />
      <div className="main-container">
        <SideBar />
        <article className="page-content">
          <section className="add-user">
            <div className="add-user__top">
              <Link to="/users">
                <img
                  className="add-user__top-icon"
                  src={chevronLeft}
                  alt="chevron pointing left"
                ></img>
              </Link>
              <h1 className="add-user__top-heading">Adding new user</h1>
            </div>

            <form onSubmit={handleAddUserSubmit} className="add-user__form">
              <section className="add-user__form--left">
                {/* The Admin dropdown was removed: POST /users/firebase does
                    delete data.admin, so picking Yes set nothing and said
                    nothing. Admin rights are granted through their own flow. */}

                <div>
                  <div>
                    <InputForm
                      placeholder="Name"
                      label="Name"
                      type="text"
                      id="name"
                      name="name"
                      value={firstName}
                      onChange={(event) =>
                        setFirstName(event.target.value)
                      }
                      error={errors.firstName}
                    />

                  </div>

                  <div>
                    <InputForm
                      placeholder="Last Name"
                      label="Last Name"
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={lastName}
                      onChange={(event) =>
                        setLastName(event.target.value)
                      }
                      error={errors.lastName}
                    />
                  </div>
                </div>

                <div>
                  <div>
                    <InputForm
                      placeholder="Phone"
                      label="Phone"
                      type="text"
                      id="phone"
                      name="phone"
                      value={phone}
                      onChange={(event) =>
                        setPhone(event.target.value)
                      }
                      error={errors.phone}
                    />
                  </div>
                  <div>
                    <InputForm
                      placeholder={delivery === 'login_link' ? 'Optional for a sign-in link' : 'Email'}
                      label="Email"
                      type="text"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(event) =>
                        setEmail(event.target.value)
                      }
                      error={errors.email}
                    />
                  </div>
                </div>


                <div>
                  <div>
                    <SelectForm
                      label="Gender"
                      options={optionsGender}
                      value={optionsGender?.value}
                      onChange={(selectedOption) => {
                        console.log(selectedOption);
                        setGender(selectedOption.value);
                      }}
                      error={errors.gender}
                    />
                  </div>

                  <div>
                    <FormDatePicker onBirthdaySelect={handleBirthdaySelect} />

                  </div>

                  <div>
                    <SelectForm
                      label="How they get in"
                      options={optionsDelivery}
                      value={optionsDelivery.find((o) => o.value === delivery)}
                      onChange={(selectedOption) => setDelivery(selectedOption.value)}
                    />
                  </div>
                </div>


                <div>
                  <Button
                    type="submit" 
                    primaryBtn
                    label='Save Information'
                    iconifyIconName='ic:round-check'
                    showLoading={saving}
                  />
                </div>
              </section>
            </form>
          </section>
        </article>
      </div>
    </main>
  );
}

export default AddUsers;
